import React, { FC, useMemo } from 'react';
import { Box, Grid } from '@mui/material';
import { generateRandomString } from '../../utils/string';
import { jsonPathToValue } from '../../utils/json';
import applyType from '../../utils/metadataUtils';
import useMetaData from '../../hooks/useMetaData';
import TabLoader from '../VehicleTabs/TabLoader';
import GridLabels from '../VehicleTabs/GridLabels';

type Props = {
  data: any;
  module: string;
  subModule: string;
};

const TabContent: FC<Props> = ({ data, module, subModule }) => {
  const metaData = useMetaData(module, subModule);
  const fields = useMemo(
    () =>
      data
        ? metaData?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property);
            return {
              label: row?.propertyName,
              title: applyType(row.type, value),
              id: generateRandomString(10),
              xs: row.xs,
              isOptional: row?.isOptional,
            };
          })
        : [],
    [data, metaData?.rows]
  );

  if (!metaData || !data) {
    return <TabLoader />;
  }

  return (
    <Box my={3}>
      <Grid container spacing={2}>
        <GridLabels
          labels={fields}
          labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
          titleSx={{ fontSize: '16px', fontWeight: '500', color: '#3E3E3E' }}
        />
      </Grid>
    </Box>
  );
};

export default TabContent;
